<template>
  <div>
    <div id="map" class="w-100"></div>
  </div>
</template>

<script>
import gisMixin from "../../mixins/gis";
export default {
  data() {
    return {
      map: null,
      selectedDevice: {},
    };
  },

  mixins: [gisMixin],

  props: {},

  async mounted() {
    this.loadMyMap();
  },

  computed: {
    location() {
      return this.$store.getters["socket/dashboard"].statistics.location;
    },
  },

  methods: {
    async loadMyMap() {
      if (this.location) {
        await this.LoadMapScripts();
        setTimeout(() => {
          /*Map Initialization*/
          window.MapmyIndia = mappls;
          var map = new mappls.Map("map", {
            center: [
              this.location.centerLatitude,
              this.location.centerLongitude,
            ],
            zoom: 6,
            search: false,
          });

          /*direction plugin initialization*/
          const directionInterval = setInterval(() => {
            if (window.MapmyIndia) {
              mappls.direction({
                map: map,
                start: `${this.location.startLatitude},${this.location.startLongitude}`,
                end: `${this.location.endLatitude},${this.location.endLongitude}`,
                search: false,
                alternatives: false,
                resource: false,
                geolocation: false,
                routeColor: "red",
                routeSummary: false,
              });

              clearInterval(directionInterval);
            }
          }, 100);

          const hideFooterInterval = setInterval(() => {
            const directions1 = document.getElementById("SeDV_map");
            if (directions1) directions1.style.display = "none";
            const directions = document.getElementById("resDr_map");
            if (directions) directions.style.display = "none";

            for (let i = 0; i <= 1000; i++) {
              const mapFooter = document.getElementById("mLogo" + i);
              if (mapFooter) mapFooter.style.display = "none";
              if (mapFooter && mapFooter.style.display === "none") {
                break;
              }
            }

            setTimeout(() => {
              clearInterval(hideFooterInterval);
            }, 5000);
          }, 10);
        }, 1000);
      }
    },
  },
};
</script>

<style scoped>
#map {
  /* width: 50%; */
  height: 50vh;
  margin: 0;
  padding: 0;
}

#direction {
  color: #000;
  max-width: 99%;
  width: 300px;
  position: absolute;
  z-index: 999;
  font-size: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  outline: none !important;
  top: 55px;
  border-radius: 10px;
  margin: 2px 4px;
}

#mLogo0 {
  display: none !important;
}
</style>
